/**
 * Created by Administrator on 2017/6/29.
 */

export default {
  data() {
    return {
      baseUrl: process.env.SSO_API,
      ReturnURl: ''
    };
  },
  created() {
    if (this.getUrlFn('ReturnURL')) {
      var url = this.getUrlFn('ReturnURL');
      // 校验 URL 合法性，过滤本地地址
      if (!this.isValidReturnURL(url)) {
        console.warn('[SSO] Invalid ReturnURL (localhost/internal IP), using default:', url);
        this.ReturnURl = process.env.DEFAULT_LOGIN_SUCCESS_JUMP_URL;
        localStorage.removeItem('ReturnURL');
        return;
      }
      if (url === 'http://20.dev.tuling123.com/') {
        this.ReturnURl = 'http://20.dev.tuling123.com/member/index.jhtml';
        localStorage.setItem('ReturnURL', 'http://20.dev.tuling123.com/member/index.jhtml');
      } else if (url === 'http://www.tuling123.com/') {
        this.ReturnURl = 'http://www.tuling123.com/member/index.jhtml';
        localStorage.setItem('ReturnURL', 'http://www.tuling123.com/member/index.jhtml');
      } else {
        this.ReturnURl = this.getUrlFn('ReturnURL');
        localStorage.setItem('ReturnURL', this.getUrlFn('ReturnURL'));
      }
    } else {
      if (localStorage.getItem('ReturnURL')) {
        var cachedUrl = localStorage.getItem('ReturnURL');
        // 校验缓存的 URL 是否有效
        if (this.isValidReturnURL(cachedUrl)) {
          this.ReturnURl = cachedUrl;
        } else {
          console.warn('[SSO] Invalid cached ReturnURL, clearing:', cachedUrl);
          localStorage.removeItem('ReturnURL');
          this.ReturnURl = process.env.DEFAULT_LOGIN_SUCCESS_JUMP_URL;
        }
      } else {
        this.ReturnURl = process.env.DEFAULT_LOGIN_SUCCESS_JUMP_URL;
      }
    }
    this.ReturnURl = unescape(this.ReturnURl);
  },
  methods: {
    /* 获取url参数 */
    getUrlFn(name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
      var r = window.location.search.substr(1).match(reg);
      if (r != null) {
        return unescape(r[2]);
      }
      return null;
    }
,
    /* 校验 ReturnURL 是否为有效的外部地址 */
    isValidReturnURL(url) {
      if (!url || typeof url !== 'string') {
        return false;
      }
      // 过滤本地地址和内网地址
      var invalidPatterns = [
        /^https?:\/\/(localhost|127\.0\.0\.1|0\.0\.0\.0)(:|\/|$)/i,
        /^https?:\/\/192\.168\./i,
        /^https?:\/\/10\./i,
        /^https?:\/\/172\.(1[6-9]|2[0-9]|3[0-1])\./i
      ];
      for (var i = 0; i < invalidPatterns.length; i++) {
        if (invalidPatterns[i].test(url)) {
          return false;
        }
      }
      // 确保是 http 或 https 协议
      return /^https?:\/\//i.test(url);
    }
  }
};



// WEBPACK FOOTER //
// ./src/js/public.js